const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngiology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE1E2D",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.314,4.392v23.756 c0,0,0,1.473-2.002,1.578c0,0-1.982,0.141-2.158-1.543V13.645c0,0-1.265,1.299-2.072,1.439c0,0,0.21,2.459-0.914,4.143 c0,0,0.702,4.004-1.369,5.197c0,0-1.405,0.528-1.124-0.842c0,0,1.019-1.018,0.983-2.178l-1.581,0.632c0,0-1.404,0.669-1.123-0.912 c0,0-2.633-0.422-2.143-1.757c0,0,0.247-0.737,1.721-0.211l2.458,0.49c0,0,1.72-1.612,1.615-3.896c0,0-1.685,0.14-2.037-0.281 c0,0-1.686,0.176-3.195,2.179c0,0-1.299,0.912-1.299-0.459c0,0,0.526-1.508,2.422-2.563l-1.334-1.054c0,0-3.757,0.913-4.108-1.124 c0,0,0.035-1.194,2.212-0.351c0,0-1.545-0.877-0.597-1.827c0,0,0.702-0.667,1.651,0.387l1.65,1.51c0,0,0.211-0.843-0.422-2.002 c0,0-0.421-0.983,0.457-1.158c0,0,0.773-0.352,1.159,0.913c0,0,0.492,2.036,0.387,3.406c0,0,2.879,2.879,6.463-2.036v-7.27"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 19.168,
    cy: 4.182,
    rx: 2.173,
    ry: 1.657
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngiology);
export default __webpack_public_path__ + "static/media/angiology.2474504170eebc0e44aafb333f1ac8f8.svg";
export { ForwardRef as ReactComponent };